import { useEffect, useState } from "react";

export default function Think({ fq=1000, start=1, end=3, text='', symbol='.' }) {
	const [tick, setTick] = useState(start);
	useEffect(() => {
		setTimeout(setTick, fq, p => {
			if (start > end) {
				p--;
				if (p < end) return start;
			} else {
				p++;
				if (p > end) return start;
			}
			return p;
		});
	}, [tick]);
	return text + symbol.repeat(tick);
}